export enum ExplorerLinkType {
  TX = "tx",
  ADDRESS = "address",
  TOKEN = "token",
}
